// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================================================
   MANAGE CLIENTS MODULE SPECIFIC STYLES
   ========================================================================== */

.manage-clients-container {
  padding: 32px;
  background-color: #f8fafc;
  border-radius: 16px;
  min-height: 100vh;
  font-family: 'Inter', system-ui, sans-serif;
}

.manage-clients-header-wrapper {
  margin-bottom: 24px;
}

.manage-clients-header-wrapper h2 {
  font-size: 24px;
  color: #0f172a;
  margin: 0 0 4px 0;
  font-weight: 700;
}

.manage-clients-subtitle {
  font-size: 14px;
  color: #64748b;
  margin: 0;
}

/* Actions Bar layout */
.manage-clients-actions-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  gap: 16px;
}

.manage-clients-search-box-wrapper {
  position: relative;
  flex: 1 1;
  max-width: 450px;
}

.manage-clients-search-icon {
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  width: 16px;
  height: 16px;
  color: #94a3b8;
}

.manage-clients-search-input {
  width: 100%;
  padding: 10px 14px 10px 40px;
  border: 1px solid #cbd5e1;
  border-radius: 10px;
  font-size: 14px;
  background-color: #ffffff;
  color: #1e293b;
  box-sizing: border-box;
}

.manage-clients-search-input:focus {
  outline: none;
  border-color: #2563eb;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.15);
}

/* Add Button style */
.manage-clients-btn-add-client {
  display: inline-flex;
  align-items: center;
  width: 150px;
  gap: 8px;
  background-color: #0f172a;
  color: #ffffff;
  padding: 10px 20px;
  border: none;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.manage-clients-btn-add-client:hover {
  background-color: #1e293b;
  transform: translateY(-1px);
}

.manage-clients-btn-icon {
  width: 16px;
  height: 16px;
}

/* Premium Layout Table */
.manage-clients-table-wrapper {
  background: #ffffff;
  border-radius: 14px;
  border: 1px solid #e2e8f0;
  overflow-x: auto;
  box-shadow: 0 1px 3px rgba(0,0,0,0.02);
}

.manage-clients-pro-table {
  width: 100%;
  border-collapse: collapse;
  text-align: left;
  font-size: 14px;
}

.manage-clients-pro-table th {
  background-color: #f8fafc;
  color: #475569;
  font-weight: 600;
  padding: 14px 20px;
  border-bottom: 1px solid #e2e8f0;
}

.manage-clients-pro-table td {
  padding: 14px 20px;
  border-bottom: 1px solid #f1f5f9;
  color: #334155;
  vertical-align: middle;
}

.manage-clients-text-bold {
  font-weight: 600;
  color: #0f172a;
}

.manage-clients-network-badge {
  background-color: #f1f5f9;
  color: #475569;
  padding: 4px 10px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  border: 1px solid #e2e8f0;
}

.manage-clients-name-text {
  font-weight: 600;
  color: #1e293b;
}

.manage-clients-contact-cell {
  display: flex;
  flex-direction: column;
}

.manage-clients-email-text {
  color: #1e293b;
}

.manage-clients-phone-text {
  font-size: 12px;
  color: #64748b;
  margin-top: 2px;
}

/* Status Configuration pills */
.manage-clients-status-badge {
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  display: inline-block;
  text-transform: capitalize;
}

.manage-clients-status-badge.active {
  background-color: #dcfce7;
  color: #15803d;
}

.manage-clients-status-badge.inactive {
  background-color: #fee2e2;
  color: #b91c1c;
}

/* Table Actions Button */
.manage-clients-btn-action-edit {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background-color: #f1f5f9;
  color: #334155;
  padding: 6px 12px;
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.manage-clients-btn-action-edit:hover {
  background-color: #e2e8f0;
  color: #0f172a;
}

.manage-clients-action-icon {
  width: 14px;
  height: 14px;
}

/* Loading & Fallbacks states */
.manage-clients-loading-wrapper, .manage-clients-no-data-cell {
  text-align: center;
  padding: 50px 20px;
  color: #64748b;
}

.manage-clients-spinner {
  width: 28px;
  height: 28px;
  border: 3px solid #e2e8f0;
  border-top-color: #2563eb;
  border-radius: 50%;
  margin: 0 auto 12px auto;
  animation: client-spin 0.8s linear infinite;
}

@keyframes client-spin {
  to { transform: rotate(360deg); }
}

/* Responsive breakpoint styling */
@media (max-width: 768px) {
  .manage-clients-actions-bar {
    flex-direction: column;
    align-items: stretch;
  }
  .manage-clients-search-box-wrapper {
    max-width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Clients/ManageClients.css"],"names":[],"mappings":"AAAA;;+EAE+E;;AAE/E;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA,qBAAqB;AACrB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,QAAQ;EACR,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,yBAAyB;AACzB;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA,+BAA+B;AAC/B;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,yBAAyB;AACzB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,wBAAwB;EACxB,2CAA2C;AAC7C;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA,kCAAkC;AAClC;EACE;IACE,sBAAsB;IACtB,oBAAoB;EACtB;EACA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* ==========================================================================\n   MANAGE CLIENTS MODULE SPECIFIC STYLES\n   ========================================================================== */\n\n.manage-clients-container {\n  padding: 32px;\n  background-color: #f8fafc;\n  border-radius: 16px;\n  min-height: 100vh;\n  font-family: 'Inter', system-ui, sans-serif;\n}\n\n.manage-clients-header-wrapper {\n  margin-bottom: 24px;\n}\n\n.manage-clients-header-wrapper h2 {\n  font-size: 24px;\n  color: #0f172a;\n  margin: 0 0 4px 0;\n  font-weight: 700;\n}\n\n.manage-clients-subtitle {\n  font-size: 14px;\n  color: #64748b;\n  margin: 0;\n}\n\n/* Actions Bar layout */\n.manage-clients-actions-bar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 24px;\n  gap: 16px;\n}\n\n.manage-clients-search-box-wrapper {\n  position: relative;\n  flex: 1;\n  max-width: 450px;\n}\n\n.manage-clients-search-icon {\n  position: absolute;\n  left: 14px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 16px;\n  height: 16px;\n  color: #94a3b8;\n}\n\n.manage-clients-search-input {\n  width: 100%;\n  padding: 10px 14px 10px 40px;\n  border: 1px solid #cbd5e1;\n  border-radius: 10px;\n  font-size: 14px;\n  background-color: #ffffff;\n  color: #1e293b;\n  box-sizing: border-box;\n}\n\n.manage-clients-search-input:focus {\n  outline: none;\n  border-color: #2563eb;\n  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.15);\n}\n\n/* Add Button style */\n.manage-clients-btn-add-client {\n  display: inline-flex;\n  align-items: center;\n  width: 150px;\n  gap: 8px;\n  background-color: #0f172a;\n  color: #ffffff;\n  padding: 10px 20px;\n  border: none;\n  border-radius: 10px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.manage-clients-btn-add-client:hover {\n  background-color: #1e293b;\n  transform: translateY(-1px);\n}\n\n.manage-clients-btn-icon {\n  width: 16px;\n  height: 16px;\n}\n\n/* Premium Layout Table */\n.manage-clients-table-wrapper {\n  background: #ffffff;\n  border-radius: 14px;\n  border: 1px solid #e2e8f0;\n  overflow-x: auto;\n  box-shadow: 0 1px 3px rgba(0,0,0,0.02);\n}\n\n.manage-clients-pro-table {\n  width: 100%;\n  border-collapse: collapse;\n  text-align: left;\n  font-size: 14px;\n}\n\n.manage-clients-pro-table th {\n  background-color: #f8fafc;\n  color: #475569;\n  font-weight: 600;\n  padding: 14px 20px;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.manage-clients-pro-table td {\n  padding: 14px 20px;\n  border-bottom: 1px solid #f1f5f9;\n  color: #334155;\n  vertical-align: middle;\n}\n\n.manage-clients-text-bold {\n  font-weight: 600;\n  color: #0f172a;\n}\n\n.manage-clients-network-badge {\n  background-color: #f1f5f9;\n  color: #475569;\n  padding: 4px 10px;\n  border-radius: 6px;\n  font-size: 13px;\n  font-weight: 500;\n  border: 1px solid #e2e8f0;\n}\n\n.manage-clients-name-text {\n  font-weight: 600;\n  color: #1e293b;\n}\n\n.manage-clients-contact-cell {\n  display: flex;\n  flex-direction: column;\n}\n\n.manage-clients-email-text {\n  color: #1e293b;\n}\n\n.manage-clients-phone-text {\n  font-size: 12px;\n  color: #64748b;\n  margin-top: 2px;\n}\n\n/* Status Configuration pills */\n.manage-clients-status-badge {\n  padding: 4px 10px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 600;\n  display: inline-block;\n  text-transform: capitalize;\n}\n\n.manage-clients-status-badge.active {\n  background-color: #dcfce7;\n  color: #15803d;\n}\n\n.manage-clients-status-badge.inactive {\n  background-color: #fee2e2;\n  color: #b91c1c;\n}\n\n/* Table Actions Button */\n.manage-clients-btn-action-edit {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  background-color: #f1f5f9;\n  color: #334155;\n  padding: 6px 12px;\n  border: 1px solid #cbd5e1;\n  border-radius: 6px;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.manage-clients-btn-action-edit:hover {\n  background-color: #e2e8f0;\n  color: #0f172a;\n}\n\n.manage-clients-action-icon {\n  width: 14px;\n  height: 14px;\n}\n\n/* Loading & Fallbacks states */\n.manage-clients-loading-wrapper, .manage-clients-no-data-cell {\n  text-align: center;\n  padding: 50px 20px;\n  color: #64748b;\n}\n\n.manage-clients-spinner {\n  width: 28px;\n  height: 28px;\n  border: 3px solid #e2e8f0;\n  border-top-color: #2563eb;\n  border-radius: 50%;\n  margin: 0 auto 12px auto;\n  animation: client-spin 0.8s linear infinite;\n}\n\n@keyframes client-spin {\n  to { transform: rotate(360deg); }\n}\n\n/* Responsive breakpoint styling */\n@media (max-width: 768px) {\n  .manage-clients-actions-bar {\n    flex-direction: column;\n    align-items: stretch;\n  }\n  .manage-clients-search-box-wrapper {\n    max-width: 100%;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
